export const formContentStyle = {
	form: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: '12px',
		marginBottom: '16px',
	},

	passwordIcon: {
		'& svg path': {
			fill: 'var(--neutral-200)',
		},

		'& .Mui-error svg path': {
			fill: 'var(--error-500)',
		},
	},

	confirmPassword: {
		marginBottom: '4px',
	},

	checkbox: {
		marginBottom: '24px',
	},

	privacy: {
		display: 'flex',
		width: '100%',
		fontSize: '14px',
		color: 'var(--neutral-500)',
	},

	socialEmail: {
		padding: '10px 12px',
		border: '1px solid var(--neutral-200)',
		borderRadius: '4px',
		color: 'var(--neutral-500)',
		fontSize: '14px',
	},

	button: {
		fontWeight: 700,
		'& .MuiButton-endIcon': {
			transform: 'rotate(180deg)',
		},
	},
};
